import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatCurrency } from 'utils/number'
import './ContractPrice.scss'

type Props = {
  price: number,
  unit?: string,
  discount: number,
  userBagProrate?: number | null,
  userBagRestricted?: boolean,
  // If provided, this is the user's payable price after company contribution
  contributedPrice?: number
}

const ContractPrice: React.FC<Props> = ({ price, discount, unit, userBagProrate, userBagRestricted, contributedPrice }) => {
  const { t } = useTranslation()

  // Use contributedPrice (user-pay portion) if available; fall back to full price
  const basePrice = (typeof contributedPrice === 'number') ? contributedPrice : price

  const shouldShowDiscount = discount > 0 && basePrice > 0
  const hasProrate = userBagProrate !== null && userBagProrate !== undefined
  const _disc = formatCurrency(discount)
  const _price = formatCurrency(basePrice)
  const _total = formatCurrency(Math.max(0, (basePrice || 0) - (discount || 0)))

  return (
      shouldShowDiscount ?
          <div className="d-flex justify-content-center">
          <span className="benefit-price">
              {t("prices.price")} {_price}
          </span>
              <span className={hasProrate ? "benefit-discount prorated" : "benefit-discount"}>
              {t("prices.discount")} {_disc}
              {hasProrate && (
                <span className="prorated-badge">
                  {userBagRestricted ? ' (Incremental)' : ' (Disponible)'}
                </span>
              )}
          </span>
              <span className="benefit-price-total">
              {t("prices.total")} {_total}
              {unit && <small>/ {unit}</small> }
          </span>

          </div>

          :
      <span className="benefit-price">
            {t("prices.total")} {_total}
            {unit && <small>/ {unit}</small> }
      </span>

  )
}

export default ContractPrice

